import { Col, Row, Card, Modal, Form } from "antd";
import React, { useEffect, useState } from "react";
import HealthCardDetails from "./SubjectHealthReadingDetailsCard";
import { MdDashboardCustomize } from "react-icons/md";
import { useTranslation } from "react-i18next";
import {
  AppDispatch,
  getAdditionalReportListClear,
  Reading,
  useDynamicSelector,
} from "@src/redux";
import CustomTestDetails from "./CustomTest";
import {
  getRiskTypeColor,
  getRiskTypeTextColor,
} from "@src/helpers/constants";
import { FaFileAlt } from "react-icons/fa";
import AdditionalReports from "../subject-last-screening-filter/AdditionalReports";
import { getUuid } from "@src/helpers/functions";
import { useDispatch } from "react-redux";
import HealthScreeningReportModal from "../../home/readings/HealthScreeningReportModal";

type Risk = {
  id: number;
  name: string;
  type: string;
};

const SubjectHealthReadingContainer: React.FC = () => {
  const { t } = useTranslation();
  const [customTestModal, setCustomTestModal] = useState<boolean>(false);
  const [otherTestItems, setOtherTestItems] = useState<any>();
  const [attachmentModal, setAttachmentModal] = useState<boolean>(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const getReadingDetails: { reading: Reading } = useDynamicSelector(
    "get_reading_details"
  );
  const handleClick = () => {
    setCustomTestModal(true);
  };

  const handleClose = () => {
    setCustomTestModal(false);
  };
  const riskList: Risk[] = [
    {
      id: 1,
      name: "Hypertension Risk",
      type:
        getReadingDetails?.reading?.readingRisk?.hypertensionRisk || "nan",
    },
    {
      id: 2,
      name: "Hypotension Risk",
      type:
        getReadingDetails?.reading?.readingRisk?.hypotensionRisk || "nan",
    },
    {
      id: 3,
      name: "Diabetic Risk",
      type: getReadingDetails?.reading?.readingRisk?.diabeticRisk || "nan",
    },
    {
      id: 4,
      name: "Obesity Risk",
      type: getReadingDetails?.reading?.readingRisk?.obesityRisk || "nan",
    },
    {
      id: 5,
      name: "Cardiac Risk",
      type: getReadingDetails?.reading?.readingRisk?.cardiacRisk || "nan",
    },
    {
      id: 6,
      name: "Respiratory Risk",
      type:
        getReadingDetails?.reading?.readingRisk?.respiratoryRisk || "nan",
    },
  ];

  useEffect(() => {
    if (
      getReadingDetails?.reading?.customTestList &&
      getReadingDetails?.reading?.customTestList?.length > 0
    ) {
      let values = Object.values(
        getReadingDetails?.reading?.customTestList?.reduce(
          (groups, test) => {
            const group = test?.customTest?.customTestGroup;

            if (group && group.id) {
              if (!groups[group.id]) {
                groups[group.id] = {
                  id: group.id,
                  name: group.name || "",
                  questions: [],
                };
              }
              if (test.value) {
                groups[group.id].questions.push({
                  name: test.customTest?.name || "",
                  value: test.value || "",
                  type: test.customTest?.type || "",
                });
              }
            }
            return groups;
          },
          {} as Record<
            string,
            {
              id: string;
              name: string;
              questions: {
                name: string;
                value: string;
                type: string;
              }[];
            }
          >
        )
      );
      setOtherTestItems(values);
    } else {
      setOtherTestItems("");
    }
  }, [getReadingDetails]);

  const handleAttachments = () => {
    if (
      getReadingDetails?.reading?.additionalReportList &&
      getReadingDetails?.reading?.additionalReportList?.length > 0
    ) {
      let bloodTest =
        getReadingDetails?.reading?.additionalReportList?.find(
          (list: any) => list?.reportName?.includes("blood_test")
        );
      let ecg = getReadingDetails?.reading?.additionalReportList?.find(
        (list: any) => list?.reportName?.includes("ecg")
      );
      let eyeTest = getReadingDetails?.reading?.additionalReportList?.find(
        (list: any) => list?.reportName?.includes("eye_test")
      );
      form.setFieldsValue({
        bloodTest: bloodTest?.fileUrl && [
          { id: getUuid(), url: bloodTest?.fileUrl, name: "View" },
        ],
        eyeTest: eyeTest?.fileUrl && [
          { id: getUuid(), url: eyeTest?.fileUrl, name: "View" },
        ],
        ecg: ecg?.fileUrl && [
          { id: getUuid(), url: ecg?.fileUrl, name: "View" },
        ],
      });
    } else {
      form.resetFields();
    }
    setAttachmentModal(true);
  };

  const onCancel = () => {
    setAttachmentModal(false);
    dispatch(getAdditionalReportListClear());
  };



  return (
    <div className="subject-health-reading-container">
      <Row>
        <Col xs={24} lg={14}>
          <HealthCardDetails />
        </Col>
        <Col
          xs={24}
          lg={10}
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
          }}
          className="subject-health-reading-subject-risk-container"
        >
          <div className="details_health_cancer_container">
            <div className="subject-risk-container">
              <span
                className="select-risk-text"
                style={{
                  backgroundColor: "#7a1343",
                  cursor: "pointer",
                }}
                onClick={handleAttachments}
              >
                {t("additional_report")}
              </span>
              <div className="risk-main-container">
                <div
                  className="risk-icon-container"
                  style={{
                    backgroundColor: "#7a1343",
                    cursor: "pointer",
                  }}
                >
                  <FaFileAlt color="white" onClick={handleAttachments} />
                </div>
              </div>
            </div>
            <div className="subject-risk-container">
              <span
                className="select-risk-text"
                style={{
                  backgroundColor:
                    otherTestItems?.length > 0 &&
                    (getReadingDetails?.reading?.customTestList?.length ??
                      0) > 0
                      ? "#7a1343"
                      : "#90496f",
                  cursor:
                    otherTestItems && otherTestItems?.length > 0
                      ? "pointer"
                      : "not-allowed",
                }}
                onClick={
                  otherTestItems && otherTestItems?.length > 0
                    ? handleClick
                    : () => {}
                }
              >
                {t("other_tests")}
              </span>
              <div className="risk-main-container">
                <div
                  className="risk-icon-container"
                  style={{
                    backgroundColor:
                      otherTestItems &&
                      otherTestItems?.length > 0 &&
                      (getReadingDetails?.reading?.customTestList?.length ??
                        0) > 0
                        ? "#7a1343"
                        : "#90496f",
                  }}
                >
                  <MdDashboardCustomize color="white" />
                </div>
              </div>
            </div>
          </div>
          <div className="details_health_cancer_container">
            {riskList.map((value, index) => (
              <Card
                className="details_health_cancer_wrapper"
                key={index}
                style={{
                  backgroundColor: getRiskTypeColor[value?.type],
                }}
              >
                <div
                  className="details_health_cancer_text"
                  style={{
                    color: getRiskTypeTextColor[value?.type],
                  }}
                >
                  {value.name}
                </div>
              </Card>
            ))}
          </div>
        </Col>
      </Row>
      <Modal
        open={customTestModal}
        footer={null}
        title={t("other_tests")}
        onCancel={handleClose}
      >
        <CustomTestDetails items={otherTestItems} />
      </Modal>
      <Modal
        title={t("additional_reports")}
        footer={null}
        open={attachmentModal}
        onCancel={onCancel}
      >
        <AdditionalReports onCancel={onCancel} form={form} />
      </Modal>
    </div>
  );
};

export default SubjectHealthReadingContainer;
